import { render, staticRenderFns } from "./UiProgress.vue?vue&type=template&id=2bc2c33f&"
import script from "./UiProgress.vue?vue&type=script&lang=js&"
export * from "./UiProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports